import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['list', 'template'];

  connect() {
    this.nextIndex = this.listTarget.querySelectorAll('.prompt-block').length;
  }

  add(event: Event) {
    event.preventDefault();

    if (this.nextIndex >= 2) return;

    const content = this.templateTarget.innerHTML.replace(/__INDEX__/g, this.nextIndex.toString());
    this.listTarget.insertAdjacentHTML('beforeend', content);
    this.nextIndex += 1;

    if (this.nextIndex >= 2) {
      (event.target as HTMLElement).remove();
    }
  }

  declare listTarget: HTMLElement;
  declare templateTarget: HTMLTemplateElement;
  declare nextIndex: number;
}
